import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import './LegalPages.css';

const Features = () => {
  return (
    <div className="legal-page">
      <Helmet>
        <title>Tmper Features | Temporary Image and File Upload</title>
        <meta
          name="description"
          content="Explore Tmper features: temporary image upload, temporary file upload up to 100MB, clipboard paste, drag-and-drop, and auto-delete after 1 hour."
        />
        <link rel="canonical" href="https://tmper.app/features" />
        <meta property="og:title" content="Tmper Features" />
        <meta
          property="og:description"
          content="Temporary uploads with clipboard paste, drag-and-drop, and 1-hour auto-delete."
        />
        <meta property="og:url" content="https://tmper.app/features" />
        <meta property="og:type" content="website" />
      </Helmet>

      <div className="legal-container">
        <Link className="back-button" to="/">
          ← Back to Upload
        </Link>

        <h1>Features</h1>
        <p className="last-updated">Fast temporary sharing, with the essentials built in.</p>

        <section>
          <h2>Temporary Links</h2>
          <p>
            Every upload is designed to be temporary. Links expire automatically after 1 hour.
          </p>
        </section>

        <section>
          <h2>Image Upload and File Upload</h2>
          <ul>
            <li>Temporary image upload for screenshots and photos</li>
            <li>Temporary file upload for documents, archives, videos, and more</li>
            <li>Up to 100MB per file (current limit)</li>
          </ul>
        </section>

        <section>
          <h2>Fast Input Methods</h2>
          <ul>
            <li>Clipboard paste for images (Ctrl+V / Cmd+V)</li>
            <li>Drag-and-drop for files</li>
            <li>One-click copy for generated links</li>
          </ul>
        </section>

        <section>
          <h2>Privacy Controls</h2>
          <p>
            Cookie preferences are configurable, and uploads are deleted automatically to reduce long-term exposure.
          </p>
          <p>
            See <Link to="/privacy">Privacy Policy</Link> for details.
          </p>
        </section>

        <section>
          <h2>Quick Links</h2>
          <ul>
            <li>
              <Link to="/temporary-image-upload">Temporary Image Upload</Link>
            </li>
            <li>
              <Link to="/temporary-file-upload">Temporary File Upload</Link>
            </li>
          </ul>
        </section>
      </div>
    </div>
  );
};

export default Features;

